import { Injectable } from '@angular/core';

import type { Observable } from 'rxjs';

import { HttpApiService } from '@core/http-legacy';
import type { ReportDashboardMetricOptions } from '@core/reports-types';

@Injectable({ providedIn: 'root' })
export class ReportsMetricsHttpClient {
  constructor(protected httpApi: HttpApiService) {}

  public fetchCollection(): Observable<{ metrics: ReportDashboardMetricOptions[] }> {
    return this.httpApi.get<{ metrics: ReportDashboardMetricOptions[] }>('/report/metrics', {
      newFormat: true,
      include_time_based: true,
      translate: true,
    });
  }
}
